const STORAGE_KEY = 'worthouseWishlist'
const COOKIE_KEY = 'worthouse_wishlist'

const readWishlist = () => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    const parsed = raw ? JSON.parse(raw) : []

    return Array.isArray(parsed) ? parsed.map(String) : []
  } catch (error) {
    return []
  }
}

const writeWishlist = (items) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items))
  } catch (error) {
    // Ignore storage failures silently.
  }
}

const writeWishlistCookie = (items) => {
  document.cookie = `${COOKIE_KEY}=${encodeURIComponent(items.join(','))}; path=/; max-age=31536000; SameSite=Lax`
}

const syncButtonState = (button, isActive) => {
  const icon = button.querySelector('i')
  button.classList.toggle('is-active', isActive)
  button.setAttribute('aria-pressed', isActive ? 'true' : 'false')
  button.setAttribute(
    'aria-label',
    isActive ? 'Remove from wishlist' : 'Add to wishlist'
  )

  if (icon) {
    icon.classList.toggle('fa-regular', !isActive)
    icon.classList.toggle('fa-solid', isActive)
  }
}

const initWishlist = () => {
  const buttons = Array.from(document.querySelectorAll('[data-wishlist-toggle][data-product-id]'))

  if (!buttons.length) {
    return
  }

  let wishlist = readWishlist()

  const updateButtons = () => {
    buttons.forEach((button) => {
      const productId = button.getAttribute('data-product-id') || ''
      syncButtonState(button, wishlist.includes(productId))
    })
  }

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      const productId = button.getAttribute('data-product-id') || ''

      if (!productId) {
        return
      }

      wishlist = wishlist.includes(productId)
        ? wishlist.filter((id) => id !== productId)
        : [...wishlist, productId]

      writeWishlist(wishlist)
      writeWishlistCookie(wishlist)
      updateButtons()
      window.dispatchEvent(new CustomEvent('worthouse:wishlist-updated', { detail: { items: wishlist } }))
    })
  })

  writeWishlistCookie(wishlist)
  updateButtons()
}

export default initWishlist



// WEBPACK FOOTER //
// ./resources/assets/js/components/wishlist.js